import mapDataToTemplate from './mapDataToTemplate';

const delay = time => new Promise(resolve => setTimeout(resolve, time));

const filterResultsByCurrentLanguage = (component, results) => {
    const lang = $(component).find('.downloads-list__lang .select :checked').val();
    let res = results;
    if (lang) {
        res = res.filter(element => $(element).attr('data-lang').includes(lang));
    }
    const types = [];
    $(component).find('.downloads-list__type .select :checked').each(function() {
        types.push($(this).val());
    });
    if (types.length) {
        res = res.filter(element => {
            let letIn = false;
            types.map((type) => {
                if ($(element).attr('data-downloadtype').includes(type)) {
                    letIn = true;
                }
                return true;
            });
            return letIn;
        });
    }

    return res;
};

/**
 * Returns a callback that handles rendering of results
 * between pagination index and offset.
 * @param {Element} component
 * @param {jQuery} $itemTemplate
 * @param {Boolean} [reset=false]
 * @returns {Function}
 */
const handlePagination = (component, $itemTemplate, reset = false) => async () => {
    const $loader = $(component).find('.loader');
    $loader.attr('data-active', true).show();

    await delay(500); // fake some loading delay

    const results = filterResultsByCurrentLanguage(component, $(component).data('results'));
    const $results = $(component).find('.downloads__list');

    if (reset) {
        // reset index and clear results
        $(component).attr('data-index', 0);
        $results.empty();
    }

    const numChildren = $results.children().length;
    const index = Number($(component).attr('data-index') || 0);
    const offset = Number($(component).attr('data-offset') || 1000);

    const slicedResults = results.slice(numChildren, index + offset);
    const items = mapDataToTemplate(slicedResults, $itemTemplate);

    $results.append(items);

    const hasRemainingItems = numChildren + items.length < results.length;
    $loader.toggle(hasRemainingItems);
    $loader.attr('data-active', false);
};

export default handlePagination;



// WEBPACK FOOTER //
// ./src/scripts/components/downloads-list/handlePagination.js